import React from "react";
import Layout from "../../components/Layout";

const Company = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow"><span className="dot"></span> Products &amp; Services</div>
                    <h1>Payment infrastructure and operational services</h1>
                    <p>
                        Everest provides a technology platform combining payment infrastructure, wallet infrastructure, and operational and infrastructure support services (delivered directly or via partners).
                    </p>
                </div>
            </section>

            {/*
              Current regulatory status (transitional). Once MiCA authorisation is granted,
              replace the statement below everywhere with:
              "Everest Network Ltd. is licensed by the Malta Financial Services Authority as a
              Crypto-Asset Service Provider under Regulation (EU) 2023/1114 on Markets in
              Crypto-Assets, as implemented in Malta by the Markets in Crypto-Assets Act."
            */}
            <section className="section section-tight">
                <div className="container">
                    <div className="notice-box">
                        <strong>Current regulatory status</strong>
                        <p style={{ marginTop: 8 }}>
                            Everest Network Ltd. is licensed by the Malta Financial Services Authority as a
                            Virtual Financial Asset Service Provider under the Virtual Financial Assets Act and
                            operates under applicable transitional arrangements pending authorisation under
                            Regulation (EU) 2023/1114 on Markets in Crypto-Assets (MiCA).
                        </p>
                        <p style={{ marginTop: 12 }}>
                            Under its current MFSA licence, Everest is authorised to provide:
                        </p>
                        <ul className="check-list micro-list">
                            <li>custody of virtual financial assets (VFAs)</li>
                            <li>execution of orders in VFAs</li>
                            <li>transfer services for VFAs</li>
                            <li>reception and transmission of orders in relation to VFAs</li>
                        </ul>
                        <p className="small-muted" style={{ marginTop: 12, fontSize: "12px" }}>
                            See our{" "}
                            <a href="/principal-adverse-impacts" style={{ color: "var(--brand)" }}>
                                Principal Adverse Impacts
                            </a>{" "}
                            disclosure for sustainability-related information.
                        </p>
                    </div>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container">
                    <div className="grid-2">
                        <article className="card">
                            <h3>Services Offered</h3>
                            <p>The platform supports the following services (delivered directly or via partners):</p>
                            <ul className="check-list micro-list">
                                <li>fiat-to-crypto on-ramp services</li>
                                <li>crypto-asset payment workflows</li>
                                <li>fiat-denominated account functionalities</li>
                                <li>stablecoin-related services (subject to market and issuer risks and regulatory permissions)</li>
                            </ul>
                            <p className="small-muted" style={{ marginTop: 12, fontSize: "12px" }}>
                                Services are provided in accordance with applicable regulatory frameworks, including MFSA requirements where relevant, and any applicable EU regulations.
                            </p>
                        </article>
                        <article className="card">
                            <h3>Delivery Model</h3>
                            <p>Services are made available via:</p>
                            <ul className="check-list micro-list">
                                <li>API integrations</li>
                                <li>embedded solutions (including widgets or iFrames)</li>
                                <li>white-label wallet solutions (EverWallet)</li>
                            </ul>
                            <p style={{ marginTop: 12 }}>Depending on the service, we may:</p>
                            <ul className="check-list micro-list">
                                <li>act as principal (where permitted under applicable regulatory permissions)</li>
                                <li>route orders to third parties</li>
                                <li>execute transactions directly (where permitted)</li>
                            </ul>
                            <p className="small-muted" style={{ marginTop: 12, fontSize: "12px" }}>
                                Information on execution is provided prior to use of services.
                            </p>
                            <p className="small-muted" style={{ marginTop: 8, fontSize: "12px" }}>
                                Some services may be provided by third-party providers. In such cases, responsibilities may be shared and different regulatory frameworks may apply.
                            </p>
                        </article>
                        <article className="card">
                            <h3>Compliance and Operational Features</h3>
                            <p>The platform includes tools designed to support:</p>
                            <ul className="check-list micro-list">
                                <li>customer due diligence (KYC) processes (client responsibility remains)</li>
                                <li>anti-money laundering (AML) control tools</li>
                                <li>transaction monitoring</li>
                                <li>wallet infrastructure</li>
                            </ul>
                            <p className="small-muted" style={{ marginTop: 12, fontSize: "12px" }}>
                                Such functionalities are provided either directly by Everest or through third-party providers, in accordance with applicable regulatory requirements.
                            </p>
                        </article>
                        <article className="card">
                            <h3>Custody and Availability</h3>
                            <p>
                                Where custody services are provided, this is done where Everest is licensed to do so and in accordance with applicable regulatory requirements. Where custody is performed by a third party, this is clearly disclosed to clients.
                            </p>
                            <p className="small-muted" style={{ marginTop: 12, fontSize: "12px" }}>
                                The availability of services may vary depending on jurisdiction and applicable regulatory requirements.
                            </p>
                        </article>
                        <article className="card" style={{ gridColumn: "1 / -1" }}>
                            <h3>Target Market and Eligibility</h3>
                            <p>Our services are intended for users who:</p>
                            <ul className="check-list micro-list">
                                <li>are legally permitted to access and use crypto-asset services</li>
                                <li>understand the risks associated with crypto-assets</li>
                                <li>are able to bear potential financial losses, including the loss of all invested capital</li>
                            </ul>
                            <p style={{ marginTop: 12 }}>Our services are not intended for:</p>
                            <ul className="check-list micro-list">
                                <li>individuals located in restricted or prohibited jurisdictions</li>
                                <li>individuals who do not meet applicable legal or regulatory requirements</li>
                                <li>users who do not understand the risks associated with crypto-assets</li>
                            </ul>
                            <p className="small-muted" style={{ marginTop: 12 }}>
                                Users are responsible for ensuring that their use of the services complies with applicable laws and regulations in their jurisdiction.
                            </p>
                        </article>
                    </div>
                    <p className="page-disclaimer" style={{ marginTop: 24 }}>
                        Crypto-asset services involve significant risk, including market volatility, liquidity risk, and the potential loss of value.
                    </p>
                    <div className="notice-box" style={{ marginTop: 18 }}>
                        <strong>IMPORTANT:</strong> This communication constitutes a marketing communication and has not been reviewed or approved by any competent authority in any Member State of the European Union.
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default Company;
